import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: 'd6cf9781-63c5-4e2b-9c68-8700bcbbe6c7',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '156763a6-a786-42d0-9b4f-026ed8457008',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -675,
      y: 253,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Christmas_UI_HARVEST_snow',
      parent: 'd6cf9781-63c5-4e2b-9c68-8700bcbbe6c7',
      data: ''
    },
    {
      id: '92786c7c-a491-4774-b23b-d382c53a1119',
      type: 'NineSlicePlane',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 602,
        y: 341
      },
      width: 1203,
      height: 682,
      leftWidth: 90,
      topHeight: 100,
      rightWidth: 90,
      bottomHeight: 100,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Christmas_window',
      parent: 'd6cf9781-63c5-4e2b-9c68-8700bcbbe6c7',
      data: ''
    },
    {
      id: '44005b9b-7b59-48a1-b017-82129ff89b5a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -567,
      y: -228,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.98,
        y: 0.98
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'splash_harvest',
      parent: 'd6cf9781-63c5-4e2b-9c68-8700bcbbe6c7',
      data: ''
    },
    {
      id: 'f232398c-1880-47fe-a82b-10ad83367abb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -332,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.99,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Christmas_UI_HARVEST_decor',
      parent: 'd6cf9781-63c5-4e2b-9c68-8700bcbbe6c7',
      data: ''
    },
    {
      id: 'd9ae67b1-b4c7-4530-aece-8f46eaf53c7a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -308,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Christmas_UI_HARVEST_title',
      parent: 'd6cf9781-63c5-4e2b-9c68-8700bcbbe6c7',
      data: ''
    },
    {
      id: '22c1c81d-341e-470e-a145-79560c1e5b5d',
      type: 'Sprite',
      name: 'ad_btn',
      nameSpace: '',
      className: '',
      x: -241,
      y: 314,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.98,
        y: 0.98
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_purple',
      parent: 'd6cf9781-63c5-4e2b-9c68-8700bcbbe6c7',
      data: ''
    },
    {
      id: '83649de2-c4a7-4f42-8251-6e0371caa1df',
      type: 'Sprite',
      name: 'collect_btn',
      nameSpace: '',
      className: '',
      x: 283,
      y: 314,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.979381,
        y: 0.98
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: 'd6cf9781-63c5-4e2b-9c68-8700bcbbe6c7',
      data: ''
    },
    {
      id: 'bbb48e5a-91bb-473c-979d-d7cc3a57d7c6',
      type: 'Sprite',
      name: 'exit_btn',
      nameSpace: '',
      className: '',
      x: 533,
      y: -265,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_close',
      parent: 'd6cf9781-63c5-4e2b-9c68-8700bcbbe6c7',
      data: ''
    },
    {
      id: 'b06cb732-7053-406b-9dd3-b11e177ff81a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 170,
      y: 94,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'harvest_coin_bg',
      parent: '44005b9b-7b59-48a1-b017-82129ff89b5a',
      data: ''
    },
    {
      id: '6a616348-8aea-42c7-b08c-bcfe8738d83d',
      type: 'Sprite',
      name: 'divider',
      nameSpace: '',
      className: '',
      x: 648,
      y: 261,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'splash_harvest_2',
      parent: '44005b9b-7b59-48a1-b017-82129ff89b5a',
      data: ''
    },
    {
      id: 'bbad4ea1-43c1-4231-b088-82280427c918',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 322,
      y: 79,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'CollectHarvest',
      localize: true,
      maxWidth: 582,
      maxHeight: 108,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#3b3b3b',
        strokeThickness: 4,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 582,
        breakWords: false,
        lineHeight: 45,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '44005b9b-7b59-48a1-b017-82129ff89b5a',
      data: ''
    },
    {
      id: 'f70af6d3-55ab-4871-b7b3-f032f1806fd0',
      type: 'Sprite',
      name: 'harvest_reward_frame_content',
      nameSpace: '',
      className: '',
      x: 664,
      y: 298,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_map_11',
      parent: '44005b9b-7b59-48a1-b017-82129ff89b5a',
      data: ''
    },
    {
      id: '85ffe21c-7ed0-421d-9dcb-6fecba2541bd',
      type: 'Container',
      name: 'layout_3',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '44005b9b-7b59-48a1-b017-82129ff89b5a',
      data: ''
    },
    {
      id: 'f5fd8e44-0f77-4a1d-8cab-dfdd710f5259',
      type: 'Container',
      name: 'layout_2',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '44005b9b-7b59-48a1-b017-82129ff89b5a',
      data: ''
    },
    {
      id: 'f8fa204c-f192-41f9-bbf5-40b1fcf5a6e8',
      type: 'Container',
      name: 'layout_1',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '44005b9b-7b59-48a1-b017-82129ff89b5a',
      data: ''
    },
    {
      id: '5f46edc6-e074-4e84-a60c-6baa96dc4466',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Harvest',
      localize: true,
      maxWidth: 431,
      maxHeight: 89,
      maxFontSize: 44,
      icons: [],
      style: {
        fontSize: 44,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#1f3f69',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'd9ae67b1-b4c7-4530-aece-8f46eaf53c7a',
      data: ''
    },
    {
      id: '95a5e8ec-20fc-4909-827d-610736562b09',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -164,
      y: -93,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ad_icon_2',
      parent: '22c1c81d-341e-470e-a145-79560c1e5b5d',
      data: ''
    },
    {
      id: '6e79c3b9-f22a-45e0-98b3-0c8b8f7227d4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 102,
      y: -115,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'double_harvest_bg',
      parent: '22c1c81d-341e-470e-a145-79560c1e5b5d',
      data: ''
    },
    {
      id: 'ec14158e-3dd2-418d-bbb1-b1ee3a09d823',
      type: 'Text',
      name: 'ad_btn_text',
      nameSpace: '',
      className: '',
      x: -2,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Collectx2',
      localize: true,
      maxWidth: 217,
      maxHeight: 92,
      maxFontSize: 49,
      icons: [],
      style: {
        fontSize: 49,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8c0154',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '22c1c81d-341e-470e-a145-79560c1e5b5d',
      data: ''
    },
    {
      id: 'f5258889-6abf-4d3a-a0f0-874e4aa86d56',
      type: 'Text',
      name: 'harvest_btn_text',
      nameSpace: '',
      className: '',
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Collect',
      localize: true,
      maxWidth: 217,
      maxHeight: 93,
      maxFontSize: 49,
      icons: [],
      style: {
        fontSize: 49,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#187630',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '83649de2-c4a7-4f42-8251-6e0371caa1df',
      data: ''
    },
    {
      id: '85266aa4-e627-4dd9-8f89-a2a6ae902f0b',
      type: 'Text',
      name: 'harvest_income_text',
      nameSpace: '',
      className: '',
      x: 159,
      y: 71,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '5050',
      localize: false,
      maxWidth: 141,
      maxHeight: 63,
      maxFontSize: 42,
      icons: [],
      style: {
        fontSize: 42,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8d231b',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0.52,
        dropShadowBlur: 5,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'b06cb732-7053-406b-9dd3-b11e177ff81a',
      data: ''
    },
    {
      id: '6a0dd75f-53ce-4a79-829d-91f50a64725a',
      type: 'Sprite',
      name: 'crop_3_4',
      nameSpace: '',
      className: '',
      x: 915,
      y: 156,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '85ffe21c-7ed0-421d-9dcb-6fecba2541bd',
      data: ''
    },
    {
      id: '80640af5-782b-48f6-8e03-1388fa7fc627',
      type: 'Sprite',
      name: 'crop_3_3',
      nameSpace: '',
      className: '',
      x: 715,
      y: 156,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '85ffe21c-7ed0-421d-9dcb-6fecba2541bd',
      data: ''
    },
    {
      id: '2e4344aa-2f0b-4c1f-993d-e4df11dca3d9',
      type: 'Sprite',
      name: 'crop_3_2',
      nameSpace: '',
      className: '',
      x: 915,
      y: 35,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '85ffe21c-7ed0-421d-9dcb-6fecba2541bd',
      data: ''
    },
    {
      id: '9c87c4ee-0213-48cf-8301-3ad02099d2d3',
      type: 'Sprite',
      name: 'crop_3_1',
      nameSpace: '',
      className: '',
      x: 715,
      y: 35,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '85ffe21c-7ed0-421d-9dcb-6fecba2541bd',
      data: ''
    },
    {
      id: '833e0efb-621d-4382-b5b3-392dd1bbcae3',
      type: 'Sprite',
      name: 'crop_2_6',
      nameSpace: '',
      className: '',
      x: 961,
      y: 154,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: 'f5fd8e44-0f77-4a1d-8cab-dfdd710f5259',
      data: ''
    },
    {
      id: 'bb2187fb-17c6-49be-bf3c-0a00df3329fa',
      type: 'Sprite',
      name: 'crop_2_5',
      nameSpace: '',
      className: '',
      x: 812,
      y: 159,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: 'f5fd8e44-0f77-4a1d-8cab-dfdd710f5259',
      data: ''
    },
    {
      id: 'e47070b6-3c4e-4458-8702-b39bfc5f65f4',
      type: 'Sprite',
      name: 'crop_2_4',
      nameSpace: '',
      className: '',
      x: 666,
      y: 157,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: 'f5fd8e44-0f77-4a1d-8cab-dfdd710f5259',
      data: ''
    },
    {
      id: '5f505d5f-f5c7-465b-8935-90ed5824b103',
      type: 'Sprite',
      name: 'crop_2_3',
      nameSpace: '',
      className: '',
      x: 958,
      y: 36,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: 'f5fd8e44-0f77-4a1d-8cab-dfdd710f5259',
      data: ''
    },
    {
      id: '28abeaff-2121-4874-887e-3f5a863e3a6d',
      type: 'Sprite',
      name: 'crop_2_2',
      nameSpace: '',
      className: '',
      x: 806,
      y: 36,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: 'f5fd8e44-0f77-4a1d-8cab-dfdd710f5259',
      data: ''
    },
    {
      id: '957b13ce-a5e2-440f-9b6a-1272c5574136',
      type: 'Sprite',
      name: 'crop_2_1',
      nameSpace: '',
      className: '',
      x: 656,
      y: 36,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: 'f5fd8e44-0f77-4a1d-8cab-dfdd710f5259',
      data: ''
    },
    {
      id: '859bd12f-9f42-49d6-8943-00773ab7a986',
      type: 'Sprite',
      name: 'crop_1_7',
      nameSpace: '',
      className: '',
      x: 957,
      y: 210,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_7_3',
      parent: 'f8fa204c-f192-41f9-bbf5-40b1fcf5a6e8',
      data: ''
    },
    {
      id: 'ed9282b9-158b-4470-8173-ae34ed36353c',
      type: 'Sprite',
      name: 'crop_1_6',
      nameSpace: '',
      className: '',
      x: 812,
      y: 163,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_6_3',
      parent: 'f8fa204c-f192-41f9-bbf5-40b1fcf5a6e8',
      data: ''
    },
    {
      id: '2854070b-253d-430f-9623-13da3fac68b3',
      type: 'Sprite',
      name: 'crop_1_5',
      nameSpace: '',
      className: '',
      x: 765,
      y: 284,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_5_3',
      parent: 'f8fa204c-f192-41f9-bbf5-40b1fcf5a6e8',
      data: ''
    },
    {
      id: 'af2c10b6-277a-4dae-9bf1-4d0a4da7c751',
      type: 'Sprite',
      name: 'crop_1_4',
      nameSpace: '',
      className: '',
      x: 650,
      y: 228,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_4_3',
      parent: 'f8fa204c-f192-41f9-bbf5-40b1fcf5a6e8',
      data: ''
    },
    {
      id: '21dc3f49-70b1-48fa-b525-56ff0ac88a71',
      type: 'Sprite',
      name: 'crop_1_3',
      nameSpace: '',
      className: '',
      x: 912,
      y: 63,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_3_3',
      parent: 'f8fa204c-f192-41f9-bbf5-40b1fcf5a6e8',
      data: ''
    },
    {
      id: 'ff7f046d-8bf7-48be-8057-6ed07cb6dccc',
      type: 'Sprite',
      name: 'crop_1_2',
      nameSpace: '',
      className: '',
      x: 783,
      y: 58,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_2_3',
      parent: 'f8fa204c-f192-41f9-bbf5-40b1fcf5a6e8',
      data: ''
    },
    {
      id: '3a19d6ea-1690-4d24-b4e4-1516f1f0553c',
      type: 'Sprite',
      name: 'crop_1_1',
      nameSpace: '',
      className: '',
      x: 642,
      y: 49,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_1_3',
      parent: 'f8fa204c-f192-41f9-bbf5-40b1fcf5a6e8',
      data: ''
    },
    {
      id: 'f26db49f-bea8-4931-8b2b-163088ae4bbf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 117,
      y: 43,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'double_harvest_coin_label',
      parent: '6e79c3b9-f22a-45e0-98b3-0c8b8f7227d4',
      data: ''
    },
    {
      id: '98c80e4b-3dc6-4d03-8570-de30a4a97422',
      type: 'Text',
      name: 'ad_harvest_income_text',
      nameSpace: '',
      className: '',
      x: 80,
      y: 75,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -17,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '10100',
      localize: false,
      maxWidth: 85,
      maxHeight: 47,
      maxFontSize: 26,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#0562b0',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '6e79c3b9-f22a-45e0-98b3-0c8b8f7227d4',
      data: ''
    },
    {
      id: '65997041-f12c-49dd-9b85-5a30d0d5f984',
      type: 'Text',
      name: 'crop_text_3_4',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '6a0dd75f-53ce-4a79-829d-91f50a64725a',
      data: ''
    },
    {
      id: 'fd6486c8-3acd-43e9-ac7c-b11f15e65ccd',
      type: 'Text',
      name: 'crop_text_3_3',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '80640af5-782b-48f6-8e03-1388fa7fc627',
      data: ''
    },
    {
      id: '5a6dae68-de4c-43de-87cd-cbd8d41ac4a7',
      type: 'Text',
      name: 'crop_text_3_2',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2e4344aa-2f0b-4c1f-993d-e4df11dca3d9',
      data: ''
    },
    {
      id: '954f1b1c-bf2f-4b2c-922d-8df3e53b0ff8',
      type: 'Text',
      name: 'crop_text_3_1',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '9c87c4ee-0213-48cf-8301-3ad02099d2d3',
      data: ''
    },
    {
      id: '40801ce4-debb-480e-8584-84b8c8fe8b98',
      type: 'Text',
      name: 'crop_text_2_6',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '833e0efb-621d-4382-b5b3-392dd1bbcae3',
      data: ''
    },
    {
      id: '9fd93d5e-62ec-4362-a2d9-22d58061ffaa',
      type: 'Text',
      name: 'crop_text_2_5',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'bb2187fb-17c6-49be-bf3c-0a00df3329fa',
      data: ''
    },
    {
      id: '272f7667-7557-482b-8cc1-c53071fa2dbf',
      type: 'Text',
      name: 'crop_text_2_4',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e47070b6-3c4e-4458-8702-b39bfc5f65f4',
      data: ''
    },
    {
      id: '978d6f61-7dd2-4586-b95f-7cc1f34010de',
      type: 'Text',
      name: 'crop_text_2_3',
      nameSpace: '',
      className: '',
      x: 13,
      y: 34,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '5f505d5f-f5c7-465b-8935-90ed5824b103',
      data: ''
    },
    {
      id: '8ad72553-bc67-457c-8341-484fb8848a18',
      type: 'Text',
      name: 'crop_text_2_2',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '28abeaff-2121-4874-887e-3f5a863e3a6d',
      data: ''
    },
    {
      id: '17444da9-399a-406e-96d5-73784839a762',
      type: 'Text',
      name: 'crop_text_2_1',
      nameSpace: '',
      className: '',
      x: 17,
      y: 36,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '957b13ce-a5e2-440f-9b6a-1272c5574136',
      data: ''
    },
    {
      id: '6643bd83-437f-4d61-a29a-7e7ca912bf66',
      type: 'Text',
      name: 'crop_text_1_7',
      nameSpace: '',
      className: '',
      x: 6,
      y: 56,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '859bd12f-9f42-49d6-8943-00773ab7a986',
      data: ''
    },
    {
      id: '1fd47c61-5bc9-44e2-bcbf-97ffd28f4172',
      type: 'Text',
      name: 'crop_text_1_6',
      nameSpace: '',
      className: '',
      x: -2,
      y: 36,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ed9282b9-158b-4470-8173-ae34ed36353c',
      data: ''
    },
    {
      id: '20968f56-47dd-4e2c-b8c0-a657165646b9',
      type: 'Text',
      name: 'crop_text_1_5',
      nameSpace: '',
      className: '',
      x: 54,
      y: 47,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2854070b-253d-430f-9623-13da3fac68b3',
      data: ''
    },
    {
      id: 'cbdee7f7-6080-4bcd-8e6b-8a508509cbc6',
      type: 'Text',
      name: 'crop_text_1_4',
      nameSpace: '',
      className: '',
      x: 8,
      y: 34,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'af2c10b6-277a-4dae-9bf1-4d0a4da7c751',
      data: ''
    },
    {
      id: 'f4434de7-1770-4916-901b-2e3e6efb929e',
      type: 'Text',
      name: 'crop_text_1_3',
      nameSpace: '',
      className: '',
      x: 39,
      y: 53,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '21dc3f49-70b1-48fa-b525-56ff0ac88a71',
      data: ''
    },
    {
      id: '97d0d715-d89f-45f0-9d56-4cc8941b90ae',
      type: 'Text',
      name: 'crop_text_1_2',
      nameSpace: '',
      className: '',
      x: 10,
      y: 34,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ff7f046d-8bf7-48be-8057-6ed07cb6dccc',
      data: ''
    },
    {
      id: '8a5a13c1-4ad1-4b92-b9c2-990c343a4e04',
      type: 'Text',
      name: 'crop_text_1_1',
      nameSpace: '',
      className: '',
      x: 12,
      y: 72,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '3a19d6ea-1690-4d24-b4e4-1516f1f0553c',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class EventFieldHarvestLayout {
  static raw = raw;
  root: PIXI.Container
  harvest_income_text: PIXI.Text
  divider: PIXI.Sprite
  harvest_reward_frame_content: PIXI.Sprite
  layout_3: PIXI.Container
  crop_3_4: PIXI.Sprite
  crop_text_3_4: PIXI.Text
  crop_3_3: PIXI.Sprite
  crop_text_3_3: PIXI.Text
  crop_3_2: PIXI.Sprite
  crop_text_3_2: PIXI.Text
  crop_3_1: PIXI.Sprite
  crop_text_3_1: PIXI.Text
  layout_2: PIXI.Container
  crop_2_6: PIXI.Sprite
  crop_text_2_6: PIXI.Text
  crop_2_5: PIXI.Sprite
  crop_text_2_5: PIXI.Text
  crop_2_4: PIXI.Sprite
  crop_text_2_4: PIXI.Text
  crop_2_3: PIXI.Sprite
  crop_text_2_3: PIXI.Text
  crop_2_2: PIXI.Sprite
  crop_text_2_2: PIXI.Text
  crop_2_1: PIXI.Sprite
  crop_text_2_1: PIXI.Text
  layout_1: PIXI.Container
  crop_1_7: PIXI.Sprite
  crop_text_1_7: PIXI.Text
  crop_1_6: PIXI.Sprite
  crop_text_1_6: PIXI.Text
  crop_1_5: PIXI.Sprite
  crop_text_1_5: PIXI.Text
  crop_1_4: PIXI.Sprite
  crop_text_1_4: PIXI.Text
  crop_1_3: PIXI.Sprite
  crop_text_1_3: PIXI.Text
  crop_1_2: PIXI.Sprite
  crop_text_1_2: PIXI.Text
  crop_1_1: PIXI.Sprite
  crop_text_1_1: PIXI.Text
  ad_btn: PIXI.Sprite
  ad_harvest_income_text: PIXI.Text
  ad_btn_text: PIXI.Text
  collect_btn: PIXI.Sprite
  harvest_btn_text: PIXI.Text
  exit_btn: PIXI.Sprite

  constructor() {
    populate(this, raw);
  }
}
